import { HttpEvent, HttpEventCallbacks, httpPost } from "@/events/eventsDomain";

export type OptionExerciseRequest = {
  grantId: string;
  trancheId: string;
  count: number;
};

export type OptionExerciseRequestTarget = Omit<OptionExerciseRequest, "count">;

export type ShareholderViewApiClient = {
  requestOptionExercise: (
    orgNo: string,
    shareholderId: number,
    request: OptionExerciseRequest,
    params: HttpEventCallbacks<unknown>,
  ) => HttpEvent<unknown>;
  editOptionExerciseRequest: (
    orgNo: string,
    shareholderId: number,
    requestId: string,
    request: OptionExerciseRequest,
    params: HttpEventCallbacks<unknown>,
  ) => HttpEvent<unknown>;
  withdrawOptionExerciseRequest: (
    orgNo: string,
    shareholderId: number,
    requestId: string,
    target: OptionExerciseRequestTarget,
    params: HttpEventCallbacks<unknown>,
  ) => HttpEvent<unknown>;
};

export const shareholderViewApiClient: ShareholderViewApiClient = {
  requestOptionExercise: (orgNo, shareholderId, request, params) =>
    httpPost({
      url: `/shareholder-view/${orgNo}/${shareholderId}/options/exercise-requests`,
      data: request,
      ...params,
    }),
  editOptionExerciseRequest: (orgNo, shareholderId, requestId, request, params) =>
    httpPost({
      url: `/shareholder-view/${orgNo}/${shareholderId}/options/exercise-requests/${requestId}`,
      data: request,
      ...params,
    }),
  withdrawOptionExerciseRequest: (orgNo, shareholderId, requestId, target, params) =>
    httpPost({
      url: `/shareholder-view/${orgNo}/${shareholderId}/options/exercise-requests/${requestId}/withdraw`,
      data: target,
      ...params,
    }),
};
